interface FormatRangeNumbersOptions {
  addSymbolDollar: boolean;
}

export const formatRangeNumbers = (
  number1: number,
  number2: number,
  options: FormatRangeNumbersOptions = { addSymbolDollar: false },
): string => {
  let num1 = (
    number1 >= 1000000 ? number1 / 1000000 : number1 >= 1000 ? number1 / 1000 : number1
  ).toFixed(1);
  num1 = num1.charAt(num1.length - 1) === '0' ? num1.slice(0, -2) : num1;
  let num2 = (
    number2 >= 1000000 ? number2 / 1000000 : number2 >= 1000 ? number2 / 1000 : number2
  ).toFixed(1);
  num2 = num2.charAt(num2.length - 1) === '0' ? num2.slice(0, -2) : num2;
  const symbolCountMoneyNum1 = number1 >= 1000000 ? 'M' : number1 >= 1000 ? 'K' : '';
  const symbolCountMoneyNum2 = number2 >= 1000000 ? 'M' : number2 >= 1000 ? 'K' : '';

  return `${options.addSymbolDollar ? '$' : ''}${num1}${symbolCountMoneyNum1} - ${
    options.addSymbolDollar ? '$' : ''
  }${num2}${symbolCountMoneyNum2}`;
};

export const formatNumberWithCommas = (number?: number) => {
  if (!number) {
    return 0;
  }

  return number.toLocaleString();
};
